<template>
  <div class="homePageGrid">
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.main = !accordion.main" :style="accordion.main ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.main ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Main</header>
        <div class="content" v-if="accordion.main">
          <div class="cardRow w3-padding-8">
            <label>Page Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.type">
              <option value="classic">Classic</option>
              <option value="one-page">Single Page</option>
              <option value="resume">Resume</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.seo = !accordion.seo" :style="accordion.seo ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.seo ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page SEO</header>
        <div class="content" v-if="accordion.seo">
          <div class="cardRow w3-padding-8">
            <label>Page Title</label>
            <input v-model="state.siteData.pages.home.seo.title" class="w3-input w3-border" />
          </div>
          <div class="cardRow w3-padding-8">
            <label>Page Keywords</label>
            <input v-model="state.siteData.pages.home.seo.keywords" class="w3-input w3-border" />
          </div>
          <div class="cardRow w3-padding-8">
            <label>Page Description</label>
            <input v-model="state.siteData.pages.home.seo.description" class="w3-input w3-border" />
          </div>
        </div>
      </div>
    </div>

    <!-- Home Slider -->
    <cmsslider  :accordion="accordion" v-on:toggleAccordion="toggleAccordion($event, 'slider')" class="gridItem"></cmsslider>
    <!-- Home Call To Action -->
    <cmshomecta :accordion="accordion" v-on:toggleAccordion="toggleAccordion($event, 'cta')" class="gridItem"></cmshomecta>
    <!-- Home About Us -->
    <cmsabout :accordion="accordion" v-on:toggleAccordion="toggleAccordion($event, 'about')" class="gridItem"></cmsabout>
    <!-- Home Sidebar -->
    <template v-if="state.siteData.content.sidebar.enabled">
      <cmssidebar :accordion="accordion" v-on:toggleAccordion="toggleAccordion($event, 'sidebar')" class="gridItem"></cmssidebar>
    </template>
    <!-- Home Features -->
    <cmsfeatures :accordion="accordion" v-on:toggleAccordion="toggleAccordion($event, 'features')" class="gridItem"></cmsfeatures>
    <!-- Home Services -->
    
    <template v-if="state.siteData.content.services.enabled">
      <cmshomeservices :accordion="accordion" v-on:toggleAccordion="toggleAccordion($event, 'services')" class="gridItem"></cmshomeservices>
    </template>

    <!-- Home Shop -->
    <template v-if="state.siteData.content.products.enabled">
      <cmshomeproducts :accordion="accordion" v-on:toggleAccordion="toggleAccordion($event, 'products')" class="gridItem"></cmshomeproducts>
    </template>

    <!-- Home Portfolio -->
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.portfolio = !accordion.portfolio" :style="accordion.portfolio ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.portfolio ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Portfolio</header>
        <div class="content" v-if="accordion.portfolio">
          <div class="cardRow w3-padding-8">
            <label>Enabled</label>
            <div class="w3-right-align">
              <label class="switch">
                <input type="checkbox" v-model="state.siteData.pages.home.sections.portfolio.enabled">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="cardRow w3-padding-8">
            <label class="w3-label">Portfolio Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.portfolio.type">
              <option value="grid-1-column-detailed">Grid 1 Column w/ Detail</option>
              <option value="construction">Construction</option>
              <!-- <option value="fullwidth">Full Width</option> -->
            </select>
          </div>
          <div class="cardRow w3-padding-8">
            <label>Text Color</label>
            <input v-model="state.siteData.pages.home.sections.portfolio.color" class="w3-input w3-border" />
          </div>
          <div class="cardRow w3-padding-8">
            <label>Background Color</label>
            <input v-model="state.siteData.pages.home.sections.portfolio.background" class="w3-input w3-border" />
          </div>
          <div class="cardRow w3-padding-8">
            <label>Divider</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.portfolio.divider">
              <option value="none">None</option>
              <option value="top">Top</option>
              <option value="bottom">Bottom</option>
              <option value="both">Both</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!-- Home Custom Content -->
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.custom = !accordion.custom" :style="accordion.custom ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.custom ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Custom</header>
        <div class="content" v-if="accordion.custom">
          <div class="cardRow w3-padding-8">
            <label>Enabled</label>
            <div class="w3-right-align">
              <label class="switch">
                <input type="checkbox" v-model="state.siteData.pages.home.sections.custom.enabled">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="input-row w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
            <label class="w3-label">Content</label>
            <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="state.siteData.pages.home.sections.custom.text"></tinymce-editor>
          </div>
        </div>
      </div>
    </div>

    <!-- Home News -->
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.news = !accordion.news" :style="accordion.news ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.news ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page News</header>
        <div class="content" v-if="accordion.news">
          <div class="cardRow w3-padding-8">
            <label>Enabled</label>
            <div class="w3-right-align">
              <label class="switch">
                <input type="checkbox" v-model="state.siteData.pages.home.sections.news.enabled">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="cardRow w3-padding-8">
            <label>Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.news.type">
              <option value="news-testimonials">News & Testimonials</option>
              <option value="law-firm">Law Firm</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Home Testimonials -->
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.testimonials = !accordion.testimonials" :style="accordion.testimonials ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.testimonials ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Testimonials</header>
        <div class="content" v-if="accordion.testimonials">
          <div class="cardRow w3-padding-8">
            <label>Enabled</label>
            <div class="w3-right-align">
              <label class="switch">
                <input type="checkbox" v-model="state.siteData.pages.home.sections.testimonials.enabled">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="cardRow w3-padding-8">
            <label>Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.testimonials.type">
              <option value="law-firm">Law Firm</option>
            </select>
          </div>
          <div class="cardRow w3-padding-8" v-if="state.siteData.pages.home.sections.testimonials.type === 'law-firm'">
            <label>Image</label>
            <div class="w3-right-align">
              <label for="file1" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
              <input id="file1" type="file" @change="uploadImage($event.target.files, 'testimonials')" ref="imageFileUpload" accept=".png,.jpg,.jpeg" class="inputFile" />
            </div>
          </div>
          <div class="w3-center w3-border-bottom w3-padding-bottom">
            <img v-if="state.siteData.pages.home.sections.testimonials.image.src !== ''" :src="state.siteData.pages.home.sections.testimonials.image.src" style="width:100%; max-width:300px;" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- Home Team -->
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.team = !accordion.team" :style="accordion.team ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.team ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Team</header>
        <div class="content" v-if="accordion.team">
          <div class="cardRow w3-padding-8">
            <label>Enabled</label>
            <div class="w3-right-align">
              <label class="switch">
                <input type="checkbox" v-model="state.siteData.pages.home.sections.team.enabled">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="cardRow w3-padding-8">
            <label>Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.team.type">
              <option value="law-firm">Law Firm</option>
            </select>
          </div>
          <div class="cardRow w3-padding-8">
            <label class="w3-label">Layout Columns</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.team.cols">
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- Home Newsletter -->
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.newsletter = !accordion.newsletter" :style="accordion.newsletter ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.newsletter ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Newsletter</header>
        <div class="content" v-if="accordion.newsletter">
          <div class="cardRow w3-padding-8">
            <label>Enabled</label>
            <div class="w3-right-align">
              <label class="switch">
                <input type="checkbox" v-model="state.siteData.pages.home.sections.newsletter.enabled">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="cardRow w3-padding-8">
            <label>URL</label>
            <input v-model="state.siteData.pages.home.sections.newsletter.url" class="w3-input w3-border" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- Home Contact -->
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.contact = !accordion.contact" :style="accordion.contact ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.contact ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Contact</header>
        <div class="content" v-if="accordion.contact">
          <div class="cardRow w3-padding-8">
            <label>Enabled</label>
            <div class="w3-right-align">
              <label class="switch">
                <input type="checkbox" v-model="state.siteData.pages.home.sections.contact.enabled">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="cardRow w3-padding-8">
            <label>Contact Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.contact.type">
              <option value="consultation">Consultation</option>
            </select>
          </div>
          <div class="cardRow w3-padding-8" v-if="state.siteData.pages.home.sections.contact.type == 'consultation'">
            <label>Title</label>
            <input v-model="state.siteData.pages.home.sections.contact.title" class="w3-input w3-border" />
          </div>
          <div class="cardRow w3-padding-8" v-if="state.siteData.pages.home.sections.contact.type == 'consultation'">
            <label>Subtitle</label>
            <input v-model="state.siteData.pages.home.sections.contact.subtitle" class="w3-input w3-border" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Editor from '@tinymce/tinymce-vue'
  import cmsslider from './cmsSlider'
  import cmsfeatures from './cmsFeatures'
  import cmshomecta from './cmsHomeCTA'
  import cmsabout from './cmsAbout'
  import cmssidebar from './cmsSidebar'
  import cmshomeproducts from './cmsHomeProducts'
  import cmshomeservices from './cmsHomeServices'
  var dataStore = require('@/dataStore').default

  export default {
    name: 'cmsPagesHome',
    data() {
      return {
        state: dataStore.state,
        accordion: {
          main: true,
          seo: false,
          slider: false,
          shop: false,
          portfolio: false,
          custom: false,
          about: false,
          sidebar: false,
          cta: false,
          features: false,
          services: false,
          news: false,
          testimonials: false,
          team: false,
          newsletter: false,
          contact: false
        }
      }
    },
    components: {
      'cmsslider': cmsslider,
      'cmsfeatures': cmsfeatures,
      'cmshomecta': cmshomecta,
      'cmsabout': cmsabout,
      'cmssidebar': cmssidebar,
      'cmshomeproducts': cmshomeproducts,
      'cmshomeservices': cmshomeservices,
      'tinymce-editor': Editor
    },
    mounted() {
      // this.resizeAllGridItems()
    },
    methods: {
      toggleAccordion(event, section) {
        this.accordion[section] = event
        // this.resizeAllGridItems()
      },
      uploadImage(files, type) {
        dataStore.uploadImage(files).then((path) => {
          this.state.siteData.pages.home.sections[type].image.src = path
        })
      },
      // resizeGridItem(item){
      //   let grid = document.getElementsByClassName("homePageGrid")[0];
      //   let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      //   let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
      //   let rowSpan = Math.ceil((item.querySelector('.inputCard').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
      //   item.style.gridRowEnd = "span " + rowSpan;
      // },
      // resizeAllGridItems(){
      //   setTimeout(() => {
      //     let allItems = document.getElementsByClassName("gridItem");
      //     for(let x = 0; x < allItems.length; x++) {
      //       this.resizeGridItem(allItems[x]);
      //     }
      //   }, 10)
      // }
    }
  }
</script>
<style scoped>
/* .homePageGrid {display: grid; grid-gap: 5px; grid-template-columns: repeat(auto-fill, minmax(440px, 1fr)); grid-auto-rows: 20px;} */
</style>


// WEBPACK FOOTER //
// src/components/cms/pages/home/cmsPagesHome.vue